import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Input, Text, useId } from '@fluentui/react-components';

export const AdditionalConversionInputPure = (props) => {
  const {
    value, onChange, size, currencySymbol, className,
  } = props;
  const id = useId('additional-conversion-value-input');
  const onInputChange = useCallback((_e, data) => {
    if (data) onChange(data.value);
  }, [onChange]);

  return (
    <Input
      className={className}
      id={id}
      value={value}
      onChange={onInputChange}
      size={size}
      contentBefore={<Text size={300}>{currencySymbol}</Text>}
    />
  );
};

AdditionalConversionInputPure.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getCurrencySymbol: PropTypes.func,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.string,
  currencySymbol: PropTypes.string,
};

AdditionalConversionInputPure.defaultProps = {
  className: '',
  size: 'medium',
  currencySymbol: '$',
};
